<template>
  <div class="select_dialog_embed">
    <div class="sales_price_mg_embed_msg">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <!--编辑-->
        <div v-if="showType === 'modify'" class="select_dialog_embed_box_content modify">
          <div>
            <span>店铺名称:</span>
            <span>{{msg.ShopName}}</span>
          </div>
          <div>
            <span>货号:</span>
            <span>{{msg.GoodsId}}</span>
          </div>
          <div>
            <span>零售价:</span>
            <span>{{msg.MarketPrice}}元</span>
          </div>
          <div>
            <span>日常价:</span>
            <input type="text" maxlength="9" v-model="dailyPrice" placeholder="日常价">
          </div>
          <div class="mb20">
            <span>活动价:</span>
            <input type="text" maxlength="9" v-model="activityPrice" placeholder="活动价">
          </div>
        </div>

        <!--删除-->
        <div v-if="showType === 'del' || showType === 'batchDel'" class="select_dialog_embed_box_content text_center mt20 mb10">
          <p>是否删除所选项?</p>
        </div>

        <!--导入-->
        <div v-if="showType === 'import'" class="select_dialog_embed_box_content text_center mt20 mb10">
          <input type="file" placeholder="选择文件" @change="tirggerFile($event)" accept=".xls,.xlsx">
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb20">
          <button class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>
    </div>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :is-suc="isSuc"
                :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
  </div>
</template>

<script>
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'sales-price-mg-embed-msg',
    props: ['title', 'showType', 'msg'],
    components: {MsgDialog, LoadingDialog},
    data() {
      return {
        dailyPrice: null, // 日常价
        activityPrice: null, // 活动价
        importFile: null, // 上传文件
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容' // 信息框内容
      }
    },
    methods: {
      // 获取单个店铺售价信息
      getShopGoodsPriceById() {
        this.$axios.get(this.Global.getShopGoodsPriceById(this.msg.Id)).then((res) => {
          if (res) {
            this.dailyPrice = res.data.resData.DailyPrice;
            this.activityPrice = res.data.resData.ActivityPrice;
          }
        });
      },

      // 修改单个店铺售价信息
      updateShopGoodsPrice() {
        if (!Number(this.dailyPrice)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '日常价只能输入输入数字';
          return;
        } else if (!Number(this.activityPrice)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '活动价只能输入输入数字';
          return;
        }
        this.loadingType = 'options';
        this.isLoading = true;
        const params = {
          id: this.msg.Id,
          dailyPrice: this.dailyPrice,
          activityPrice: this.activityPrice
        };
        this.$axios.post(this.Global.updateShopGoodsPrice, params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功';
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 删除店铺售价信息
      deleteShopGoodsPriceById() {
        this.$axios.post(this.Global.deleteShopGoodsPriceById, this.msg).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.isMsg = true;
            this.isSuc = true;
            this.txtMsg = '操作成功';
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 获取文件
      tirggerFile(e) {
        this.importFile = e.target.files;
      },

      // 导入
      importShopGoodsPriceExcel() {
        if (!this.importFile) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要导入的文件';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const formData = new FormData();
        // const formData = new window.FormData();
        formData.append('body', this.importFile[0]);
        this.$axios.post(this.Global.importShopGoodsPriceExcel, formData).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (res.data.errorMsg.length) {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              } else {
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '导入成功';
              }
            }
          }, 500);
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'import') {
          this.importShopGoodsPriceExcel();
        } else if (this.showType === 'modify') {
          this.updateShopGoodsPrice();
        } else if (this.showType === 'del' || this.showType === 'batchDel') {
          this.deleteShopGoodsPriceById();
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc) {
          this.cancelBtn(true);
        }
      }
    },
    created() {
      console.log(this.showType);
      if (this.showType === 'modify') {
        this.getShopGoodsPriceById();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .sales_price_mg_embed_msg {
    background-color: #fff;
    max-height: 100%;

    .modify {
      & > div {
        margin-top: 20px;

        span:first-child {
          display: inline-block;
          width: 70px;
          text-align: right;
          margin-left: 130px;
        }

        input[type='text'] {
          width: 100px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/sales-price-mg-embed-msg.vue